export const CREATE_TOPPICK_ACTION = '[Toppick Action] Create Toppick';
export const CONFIRMED_CREATE_TOPPICK_ACTION = '[Toppick Action] Confirmed Create Toppick';
export const GET_TOPPICKS = '[Toppick Action] Get Toppicks';
export const CONFIRMED_GET_TOPPICKS = '[Toppick Action] Confirmed Get Toppicks';
export const EDIT_TOPPICK_ACTION = '[Toppick Action] Edit Toppick';
export const CONFIRMED_EDIT_TOPPICK_ACTION = '[Toppick Action] Confirmed Edit Toppick';
export const CONFIRMED_DELETE_TOPPICK_ACTION = '[Toppick Action] Confirmed Delete Toppick';
export const CREATE_TOPPICK_ERROR_ACTION = '[Toppick Action] Error';
export const CLEAR_TOPPICK_ERROR = '[Toppick Action] Clear Error';
export const LOADING_TOPPICK = '[Offer Action] Loading for Toppicks';


